// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dynamicLobby__offerTile{flex-shrink:0;width:100%}@media (min-width:1025px){.dynamicLobby__offerTile{width:88%}.dynamicLobby__offerTile:only-child{width:100%}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
